import styles from './FJAddAccountPanel.module.less';
import FJModalClose from '@src/components/FJModals/FJModalClose/FJModalClose.tsx';
import FJLocalStore from '@src/store/FJLocalStore';
import FJSocialItem from '@src/components/FJModals/FJShareModal/FJAddAccount/FJSocialItem.tsx';
import { SOCIAL_KEY } from '@src/constants/FJShareSocialConstant.ts';
import YoutubeIcon from '../../../../assets/youtube.svg?react';
import LinkedInIcon from '../../../../assets/linkedin.svg?react';

interface Props {
    activeData: any;
    onClose: () => void;
    onAddPlatform: (type: string) => void;
}

const FJAddAccountPanel = ({ activeData, onClose, onAddPlatform }: Props) => {
    const hide = !activeData.youtube || !activeData.linkedin;
    return (
        <div className={styles.mask}>
            <div className={styles.box}>
                <FJModalClose onClick={onClose} />
                <p className={styles.header_title}>{FJLocalStore._('add-account')}</p>
                {!hide && (
                    <p className={styles.desc}>
                        {FJLocalStore._('Please connect at least one social account to start sharing videos.')}
                    </p>
                )}
                <div className={styles.item_list}>
                    {activeData.youtube && (
                        <FJSocialItem type={SOCIAL_KEY.YOUTUBE} icon={<YoutubeIcon />} onClick={onAddPlatform} />
                    )}
                    {/*{activeData.instagram && <FJSocialItem type={SOCIAL_KEY.INSTAGRAM} onClick={onAddPlatform} />}*/}
                    {activeData.linkedin && (
                        <FJSocialItem type={SOCIAL_KEY.LINKEDIN} icon={<LinkedInIcon />} onClick={onAddPlatform} />
                    )}
                </div>
            </div>
        </div>
    );
};

export default FJAddAccountPanel;
